import getStoreRecordsByMask from './get-store-records-by-mask';

export const invalidateUserConnections = (store, userId) => {
    const followingRecordIds = getStoreRecordsByMask(store, `ProfileFollowingList_following`);
    followingRecordIds.forEach(id => {
        const record = store.get(id);
        record && record.invalidateRecord();
    });
    const followersRecordIds = getStoreRecordsByMask(store, `ProfileFollowersList_followers`);
    followersRecordIds.forEach(id => {
        const record = store.get(id);
        record && record.invalidateRecord();
    });
};

export const invalidateUserFollowing = (store, userId) => {
    if (userId) {
        const followingRecordIds = getStoreRecordsByMask(store, `ProfileFollowingList_following`);
        followingRecordIds.forEach(id => {
            const record = store.get(id);
            record && record.invalidateRecord();
        });
    }
};

export const invalidateFollowingPosts = (store) => {
    const followingPostsRecordIds = getStoreRecordsByMask(store, `FollowingPostsList_followingPosts`);
    followingPostsRecordIds.forEach(id => {
        const record = store.get(id);
        record && record.invalidateRecord();
    });
};

export const invalidateForMePosts = (store) => {
    // Invalidate all "for me" connections.
    // Both the /vibe/for-me page and the home Vibe section use the same
    // connection key: ForMePostsList_forMePosts, so this is sufficient.
    const forMePostsRecordIds = getStoreRecordsByMask(store, `ForMePostsList_forMePosts`);
    forMePostsRecordIds.forEach(id => {
        const record = store.get(id);
        record && record.invalidateRecord();
    });
};

export const invalidateProfilePosts = (store) => {
    const profilePostsRecordIds = getStoreRecordsByMask(store, `ProfilePostsList_posts`);
    profilePostsRecordIds.forEach(id => {
        const record = store.get(id);
        record && record.invalidateRecord();
    });
};

